(() => {
  const STORAGE_KEY = 'hersh_wishlist_v1';
  const MAX_ITEMS = 100;

  function readWishlist() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    const clean = Array.from(new Set(items.filter(Boolean))).slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
    return clean;
  }

  function hasProduct(handle) {
    return readWishlist().includes(handle);
  }

  function updateButton(button, wishlist) {
    const handle = button.dataset.productHandle;
    if (!handle) return;

    const active = wishlist.includes(handle);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.classList.toggle('is-wishlisted', active);

    const title = button.dataset.productTitle || 'this product';
    button.setAttribute(
      'aria-label',
      active ? `Remove ${title} from wishlist` : `Add ${title} to wishlist`
    );

    const addLabel = button.querySelector('[data-wishlist-add-label]');
    const removeLabel = button.querySelector('[data-wishlist-remove-label]');

    if (addLabel) addLabel.hidden = active;
    if (removeLabel) removeLabel.hidden = !active;
  }

  function updateHeaderCount(wishlist) {
    const count = wishlist.length;

    document.querySelectorAll('[data-wishlist-count]').forEach((element) => {
      element.textContent = count;
      element.dataset.count = String(count);
      element.hidden = count === 0;
    });

    document.querySelectorAll('[data-wishlist-header-link]').forEach((link) => {
      link.setAttribute(
        'aria-label',
        count > 0 ? `Wishlist, ${count} item${count === 1 ? '' : 's'}` : 'Wishlist'
      );
    });
  }

  function updateAll() {
    const wishlist = readWishlist();

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      updateButton(button, wishlist);
    });

    updateHeaderCount(wishlist);
  }

  function toggleWishlist(handle) {
    if (!handle) return readWishlist();

    const wishlist = readWishlist();
    const index = wishlist.indexOf(handle);

    if (index >= 0) {
      wishlist.splice(index, 1);
    } else {
      wishlist.unshift(handle);
    }

    const updated = writeWishlist(wishlist);
    updateAll();

    window.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          items: updated,
          handle,
          wishlisted: updated.includes(handle)
        }
      })
    );

    return updated;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    toggleWishlist(button.dataset.productHandle);
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      updateAll();
      window.dispatchEvent(
        new CustomEvent('wishlist:updated', {
          detail: { items: readWishlist() }
        })
      );
    }
  });

  document.addEventListener('shopify:section:load', updateAll);

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      updateAll();
    });
  });

  function init() {
    updateAll();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.HershWishlist = {
    key: STORAGE_KEY,
    get: readWishlist,
    has: hasProduct,
    toggle: toggleWishlist,
    refresh: updateAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
